<script>

import {VOtpInput} from "vuetify/lib/components";

export default {
  mixins: [VOtpInput],
  name: 'password-input',

  methods: {
    genInput (otpIdx) {
      const listeners = Object.assign({}, this.listeners$)
      delete listeners.change // Change should not be bound externally

      return this.$createElement('input', {
        style: {},
        domProps: {
          value: this.otp[otpIdx],
          min: this.type === 'number' ? 0 : null,
        },
        attrs: {
          ...this.attrs$,
          disabled: this.isDisabled,
          readonly: this.isReadonly,
          type: this.type,
          id: `${this.computedId}--${otpIdx}`,
          class: `otp-field-box--${otpIdx}`,
        },
        on: Object.assign(listeners, {
          blur: this.onBlur,
          input: (e) => this.onInput(e, otpIdx),
          focus: (e) => this.onFocus(e, otpIdx),
          keydown: this.onKeyDown,
          keyup: (e) => this.onKeyUp(e, otpIdx),
        }),
        ref: 'input',
        refInFor: true,
      })
    },
  }
}
</script>
